// benefitTypeSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { EsicBenefitTypeState } from './BenefitType';
import {
  createEsicBenefitType,
  fetchEsicBenefitTypeList,
  fetchEsicBenefitTypeById,
  updateEsicBenefitType,
  deleteEsicBenefitType,
} from './benefitAction';

const initialState: EsicBenefitTypeState = {
  benefitTypeList: [],
  selectedBenefitType: undefined,
  loading: false,
  error: undefined,
};

const esicBenefitTypeSlice = createSlice({
  name: 'esicBenefitType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createEsicBenefitType.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createEsicBenefitType.fulfilled, (state, action) => {
        state.loading = false;
        state.benefitTypeList.push({
          ...action.meta.arg,
          benefit_id: action.payload.id,
        });
      })
      .addCase(createEsicBenefitType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All
      .addCase(fetchEsicBenefitTypeList.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchEsicBenefitTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.benefitTypeList = action.payload.data;
      })
      .addCase(fetchEsicBenefitTypeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchEsicBenefitTypeById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchEsicBenefitTypeById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedBenefitType = action.payload;
      })
      .addCase(fetchEsicBenefitTypeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update
      .addCase(updateEsicBenefitType.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateEsicBenefitType.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.benefitTypeList.findIndex(
          (item) => item.benefit_id === action.meta.arg.id
        );
        if (index !== -1) {
          state.benefitTypeList[index] = {
            ...state.benefitTypeList[index],
            ...action.meta.arg,
          };
        }
      })
      .addCase(updateEsicBenefitType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete
      .addCase(deleteEsicBenefitType.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteEsicBenefitType.fulfilled, (state, action) => {
        state.loading = false;
        state.benefitTypeList = state.benefitTypeList.filter(
          (item) => item.benefit_id !== action.meta.arg
        );
      })
      .addCase(deleteEsicBenefitType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default esicBenefitTypeSlice.reducer;
